export const SUCCESS_RESPONSE = "Success"
export const FAILED_RESPONSE = "Failed"

export const ModalTypeSuccess = 'Success'
export const ModalTypeFail = 'Fail'
export const ModalTypeLoading = 'Loading'
export const ModalTypeConfirmation = 'Confirmation'

export const ApiResponseSuccess = 1
export const APiResponseError = 0
export const ApiResponseStatusOk = 200
export const ApiResponseStatusNotFound = 400
export const ApiResponseStatusUnauthorized = 401
export const ApiResponseStatusInternalServerError = 500

export const StatusCodeActive = "1"
export const StatusCodeDelete = "2"

export const AxiosNetworkError = "ERR_NETWORK"

export const EmptyString = ""
export const Undefined = "undefined"
export const DefaultErrorMessage = "An error has occured. Please contact IT Support"

export const FormTypeAdd = "Add"
export const FormTypeEdit = "Edit"
export const FormTypeView = "View"

export const PageSize = 25

export const PaginationFirst = "First"
export const PaginationBack = "Back"
export const PaginationNext = "Next"
export const PaginationLast = "Last"

export const DateNullDefault = "0001-01-01T00:00:00"

export const Active = "Active"
export const Deleted = "Deleted"

export const DateInsertFormat = "yyyy-MM-DD"
export const SmallDateFormat = "DD MMM yyyy"

export const SidebarOpen = "open"
export const SidebarClose = "close"

export const DropdownStatusList = [
    {label: "All", value: ""},
    {label: "Active", value: "1"},
    {label: "Delete", value: "2"}
]
export const DropdownPageSizeOptions = [
    {label: "25", value: "25"},
    {label: "50", value: "50"},
    {label: "100", value: "100"},
    {label: "All", value: ""}
]
export const SalesStockStatusOptions = [
    {label: "All", value: ""},
    {label: "Available", value: "1"},
    {label: "Sold", value: "2"}
]
export const RentalStockStatusOptions = [
    {label: "All", value: ""},
    {label: "Available", value: "1"},
    {label: "Rented", value: "2"},
    {label: "Sold", value: "3"}
]



